// Variables
var lang = $("html").attr("lang"),
  body = $("body"),
  windowWidth,
  opacity = ".5",
  slideInterval = 0;

$(document).ready(function () {
  if (window.location.pathname != "/fr") {
  }

  $(".categories-button").click(function () {
    if ($(".categories-menu").is(":hidden")) {
      $(".categories-menu").slideDown("fast");
    } else {
      $(".categories-menu").slideUp("fast");
    }
  });
});

$(".mosaic-select").click(function () {
  $(".mosaic-select").removeClass("active");
  $(this).addClass("active");
  if ($(this).hasClass("mosaic-select-team")) {
    $(".partners-team").show();
    $(".partners-team").css("display", "flex");
    $(".partners-advisors").hide();
  } else {
    $(".partners-team").hide();
    $(".partners-advisors").show();
    $(".partners-advisors").css("display", "flex");
  }
});

var menuShown = false;

$(".burger").click(function () {
  if (menuShown) {
    $(".header").removeClass("menuShown");
    menuShown = false;
  } else {
    $(".header").addClass("menuShown");
    menuShown = true;
  }
});

function myFunction(x) {
  x.classList.toggle("change");
}

$("#myMenu>li").click(function () {
  if ($(window).width() < 740) {
    $(".header").removeClass("menuShown");
    menuShown = false;
    $(".burger").removeClass("change");
  }
});

const toTop = document.getElementById("go-top");

toTop.addEventListener("click", () => {
  console.log("test");
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
});
